import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { roleNames } from "../constant";

const Home = () => {
  const role = useSelector((state) => state.auth.role);
  const token = useSelector((state) => state.auth.token);

  if (!token) return <Navigate to="/login" />;

  if (role === roleNames.superAdmin) return <Navigate to="/admin-dashboard" />;
  if (role === roleNames.qa) return <Navigate to="/qa-dashboard" />;

  return <Navigate to="/unauthorized" />;
};

export default Home;
